export default __webpack_public_path__ + "static/neue-haas-grotesk-text-66-medium-italic-e46dbea8140e0c2254af184e0c2d19d5.woff";